<template>
  <div class="change-size cursor-pointer ml-3" @click="changeFontSize">
    <div id="size-button" class="flex-column align-center justify-center">
      <i class="iconfont icon-daxiao right-bar_icon cursor-pointer"></i>
      <span class="operate-text">大小</span>
    </div>
    <ion-popover
      :is-open="selectOptionsVisible"
      :arrow="false"
      :show-backdrop="false"
      trigger="size-button"
      trigger-action="click"
      class="size-popover"
    >
      <ion-content>
        <div class="flex-row justify-evenly" :class="aiTheme">
          <div
            v-for="(size, index) in fontSizes"
            :key="index"
            class="mt-2 mb-2 mr-2 ml-2 cursor-pointer"
            :class="{ 'font-size-selected': size === currentSize }"
            @click="changeFontStyle(size)"
          >
            {{ SizeNameMap[size] }}
          </div>
        </div>
      </ion-content>
    </ion-popover>
  </div>
</template>

<script setup lang="ts">
import { defineEmits, defineProps, ref, withDefaults } from "vue"
import { SizeNameMap, SizeStyleMap } from "./infoConfig"
import { useStorage } from "@vueuse/core"

const props = withDefaults(
  defineProps<{
    modelValue: any
  }>(),
  {
    modelValue: SizeStyleMap["small"],
  }
)
const emits = defineEmits(["update:modelValue"])
const currentSize = ref("small")
const fontSizes = ["small", "medium", "large"]
const fontStyle = ref(props.modelValue)
const selectOptionsVisible = ref(false)
const aiTheme = useStorage("ai-theme", "brown")

function changeFontStyle(size: string) {
  currentSize.value = size
  fontStyle.value = SizeStyleMap[size]
  emits("update:modelValue", fontStyle.value)
  changeFontSize()
}

function changeFontSize() {
  selectOptionsVisible.value = !selectOptionsVisible.value
}
</script>

<style scoped lang="less">
@import "@/theme/ai-theme.less";

.change-size {
  position: relative;

  .size-popover {
    &::part(content) {
      --box-shadow: 0 0 1px 0 var(--font-grey-color);
      display: flex;
      flex-direction: row;
    }
  }
}

.right-bar_icon {
  font-size: 20px;
  color: var(--icon-color, #262626);
}

.operate-text {
  font-size: var(--font-pure-2);
  white-space: nowrap;
  color: var(--icon-color, #262626);
}

.font-size-selected {
  color: var(--text-import-color, #b35f34);
}
</style>
